import {useState} from "react";
import {Plus, X} from "lucide-react";
import {errMsg} from "@/components/cms/common";
import {PushToggle} from "@/components/PushToggle";

export const SettingsTab = ({settings, call, reload}) => {
  const [pct, setPct] = useState(settings.member_discount_percent), [minDp, setMinDp] = useState(settings.min_dp), [nums, setNums] = useState(settings.central_numbers), [msg, setMsg] = useState("");
  const setNum = (i, k, v) => setNums(n => n.map((x, j) => (j === i ? {...x, [k]: v} : x)));
  const save = async () => {
    if (pct === "" || Number(pct) < 0 || Number(pct) > 100) return setMsg("Diskon harus 0–100");
    try { await call("put", "/settings", {member_discount_percent: Number(pct), min_dp: Number(minDp), central_numbers: nums}); setMsg("Pengaturan tersimpan"); reload(); } catch (e) { setMsg(errMsg(e)); }
  };
  return <div className="cms-settings">
    <section className="cms-form">
      <h3>Membership</h3>
      <label>Diskon member (%)<input data-testid="cms-discount-input" type="number" min="0" max="100" value={pct} onChange={e => setPct(e.target.value)}/></label>
      <label>DP minimal booking web (Rp)<input data-testid="cms-min-dp-input" type="number" min="10000" step="1000" value={minDp} onChange={e => setMinDp(e.target.value)}/></label>
      <h3>Nomor notifikasi pusat</h3>
      <p className="muted">Kontak pusat yang menerima notifikasi pesanan dari semua outlet.</p>
      {nums.map((n, i) => <div className="num-row" key={i}>
        <input data-testid={`cms-central-label-${i}`} value={n.label} onChange={e => setNum(i, "label", e.target.value)} placeholder="Jabatan"/>
        <input data-testid={`cms-central-wa-${i}`} value={n.wa_number} onChange={e => setNum(i, "wa_number", e.target.value)} placeholder="628xx"/>
        <button type="button" aria-label="Hapus nomor" data-testid={`cms-central-remove-${i}`} onClick={() => setNums(x => x.filter((_, j) => j !== i))}><X size={14}/></button>
      </div>)}
      <button type="button" className="link-btn" data-testid="cms-central-add" onClick={() => setNums(x => [...x, {label: "", wa_number: ""}])}><Plus size={14}/> Tambah nomor</button>
      <div className="cms-form-actions"><button className="primary-btn" data-testid="cms-settings-save" onClick={save}>Simpan pengaturan</button>{msg && <span className="settings-msg" data-testid="cms-settings-message">{msg}</span>}</div>
    </section>
    <section className="cms-form">
      <h3>Notifikasi browser</h3>
      <p className="muted">Aktifkan di setiap perangkat yang ingin menerima pemberitahuan booking baru dari semua outlet.</p>
      <PushToggle save={sub => call("post", "/push/subscribe", sub)} remove={sub => call("post", "/push/unsubscribe", sub)} hint="Pemberitahuan muncul walau tab ini tidak sedang dibuka."/>
    </section>
  </div>;
};
